import { createSharedComposable } from '@vueuse/core';
import { inject } from 'vue';

export const useGameDash = createSharedComposable(() => {
	return inject('gamedash');
});
